"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationChanel = void 0;
const topic_1 = require("../../topic");
const NAVIGATION_CHANNEL = 'navigation';
class NavigationChanel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = NAVIGATION_CHANNEL;
        this.topics = {
            openApp: new topic_1.Topic('openApp', NAVIGATION_CHANNEL, this._logger),
            overlayClicked: new topic_1.Topic('overlayClicked', NAVIGATION_CHANNEL, this._logger),
            changeBrowserURI: new topic_1.Topic('changeBrowserURI', NAVIGATION_CHANNEL, this._logger),
            Deactivate: new topic_1.Topic('Deactivate', NAVIGATION_CHANNEL, this._logger),
            Navigate: new topic_1.Topic('Navigate', NAVIGATION_CHANNEL, this._logger),
            performAction: new topic_1.Topic('performAction', NAVIGATION_CHANNEL, this._logger)
        };
    }
}
exports.NavigationChanel = NavigationChanel;
//# sourceMappingURL=navigation.channel.js.map